import { Center, Loader } from "@mantine/core";

export default function PageFallback() {
  return (
    <Center mih="100dvh">
      <Loader aria-label="Loading" />
    </Center>
  );
}
